import React, { useContext, useEffect, useState } from 'react';
import { getFeatureContextFromToken } from '@hiiretail/feature-context';
import { AuthContext } from '../../auth/Auth';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { Flexbox, Spinner } from '@hiiretail/synergy-ui';

type ContentProps = {
  children?: React.ReactNode;
};

const Content: React.FC<ContentProps> = ({ children }) => <>{children}</>;

const globalWithEnv = globalThis as typeof globalThis & {
  env: {
    launchDarkly: {
      clientSideID: string;
    };
  };
};

export const FeatureFlagsWrapper: React.FC = ({ children }) => {
  const [ldContext, setLdContext] = useState<ReturnType<typeof getFeatureContextFromToken> | null>(
    null,
  );
  const { currentUser } = useContext(AuthContext);
  useEffect(() => {
    currentUser?.getIdToken().then((token) => {
      setLdContext(getFeatureContextFromToken(token));
    });
  }, [currentUser]);

  const Wrapped = ldContext
    ? withLDProvider({
        user: ldContext?.context,
        clientSideID: globalWithEnv.env.launchDarkly.clientSideID,
      })(Content)
    : () => (
        <Flexbox container justifyContent="center" alignItems="center">
          <Spinner dataTestId="feature-flags-spinner" />
        </Flexbox>
      );

  return <Wrapped>{children}</Wrapped>;
};
